import { useState } from "react";
import { HQ } from "./sportConfig";

// Explicit links override this device's preference without rewriting it.
export default function useLeagueSelection(searchParams, view = "daily") {
  const key = `${HQ.storagePrefix}-${view}-leagues`;
  const [saved, setSaved] = useState(() => {
    try {
      const value = JSON.parse(window.localStorage.getItem(key) || "[]");
      return Array.isArray(value) ? value.filter(item => typeof item === "string" && item) : [];
    } catch { return []; }
  });
  const selected = searchParams.has("league") ? searchParams.getAll("league").filter(Boolean) : saved;
  const save = value => {
    setSaved(value);
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch {}
  };
  return [selected, save];
}
